"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeCharacteristicStateValueSchema = void 0;
const zod_1 = require("zod");
const AbsoluteCharacteristicValue_1 = require("./AbsoluteCharacteristicValue");
exports.RelativeCharacteristicStateValueSchema = AbsoluteCharacteristicValue_1.AbsoluteCharacteristicValueSchema.extend({
    relativeToNet: zod_1.default.string().optional(),
});
//# sourceMappingURL=RelativeCharacteristicStateValue.js.map